import { useControls } from 'react-zoom-pan-pinch';

export const useZoomControlsController = () => {
    const { zoomIn, zoomOut } = useControls();

    return {
        handleZoomIn: () => zoomIn(),
        handleZoomOut: () => zoomOut()
    };
};
